<script setup>
const props = defineProps(["faqs"]);

import { ref } from "vue";
import ChevronUp from "@/components/icons/ChevronUp.vue";
import TransitionExpand from "@/components/transitions/TransitionExpand.vue";

const activeFaq = ref(null);

const toggleFaq = (faq) => {
	activeFaq.value = activeFaq.value === faq ? null : faq;
};
</script>

<template>
	<section class="pb-64 md:py-120">
		<div class="container">
			<div class="grid grid-cols-12 gap-y-48">
				<div class="col-span-12 lg:col-span-6">
					<h2 class="sm:h3 h5 font-primary lg:max-w-150">
						Frequently Asked Questions
					</h2>
				</div>
				<ul
					class="col-span-12 flex flex-col gap-24 lg:col-span-6 lg:gap-32"
				>
					<li
						class="w-full border-b border-(--theme-surface)/10 pb-24 lg:pb-32"
						v-for="faq in faqs"
						:key="faq.question"
					>
						<button
							class="flex w-full items-center justify-between text-left"
							@click="toggleFaq(faq)"
						>
							<h3 class="h6 font-primary-condensed">
								{{ faq.question }}
							</h3>
							<div
								class="shrink-0 transition-transform duration-500"
								:class="{ 'rotate-180': activeFaq === faq }"
							>
								<ChevronUp />
							</div>
						</button>
						<TransitionExpand>
							<div v-if="activeFaq === faq">
								<div class="pt-20">
									<p>{{ faq.answer }}</p>
								</div>
							</div>
						</TransitionExpand>
					</li>
				</ul>
			</div>
		</div>
	</section>
</template>
